import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { CustomShortcutsModule } from '../../../component/custom-shortcuts/custom-shortcuts.module';

@NgModule({
  declarations: [
    ToolbarComponent
  ],
  imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,

    FuseSharedModule,
    FuseSearchBarModule,
    FuseShortcutsModule,

    CustomShortcutsModule,
    TranslateModule,
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule { }
